module.exports = __webpack_public_path__ + "static/media/banner-image.423b4b97.png";